import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * home module ServiceStores.
 * Declares the services its ViewStores consume (migrated off the removed
 * createRestApi). Each entry: { name: <feathers service path>, options }.
 */
export const homeStores: ServiceStoreConfig[] = [
  // Find-only, whole-platform rollup for the Command Center landing dashboard.
  // ONE find() returns ONE composite object (no `{ data }` pagination envelope,
  // no entity list) — so the CommandCenterStore reads the find() RESULT, not
  // the entity cache. enableStorage off (it's a live rollup, never persisted).
  // enableOffline OFF is REQUIRED: the offline-capable store only understands
  // paginated/array responses, so it would leave this bare composite null,
  // crash in cacheResults(null), and silently blank the dashboard. The plain
  // ServiceStore returns the composite verbatim and surfaces fetch errors as a
  // null result (which CommandCenterStore renders as a Retry state).
  {
    name: "dashboard-summary",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
];
